export default __webpack_public_path__ + "static/media/trr-food-pastry-6.e314a05a.png";